import { Controller } from "@hotwired/stimulus"
import { getCSRFToken } from "web-ui/csrf"
import * as Log from "web-ui/log"

// Connects to data-controller="turbo-stream-button"
export default class extends Controller {
  static values = {
    method: String,
    url: String,
  };

  connect() {
    this.debug("Connect", { method: this.methodValue, url: this.urlValue})

    this.element.addEventListener("click", this.click)
  }

  disconnect() {
    this.debug("Disconnect")

    this.element.removeEventListener("click", this.click);
  }

  click = async (event) => {
    this.debug(`Click event: ${event}`)

    const csrfToken = getCSRFToken()

    const headers = {
      "Accept": "text/vnd.turbo-stream.html",
      "X-CSRF-Token": csrfToken
    }

    try {
      const method = this.methodValue
      const url = this.urlValue

      const response = await fetch(url, { headers, method })

      const responseContentType = response.headers.get("Content-Type")

      if (!this.isTurboStreamContentType(responseContentType)) {
        this.debug("Response error: ", { response })
        return
      }

      const html = await response.text()

      this.debug("Rendering")

      Turbo.renderStreamMessage(html)

      this.debug("Refreshed")

    } catch(error) {
      Sentry.captureException(error)
    }
  }

  isTurboStreamContentType(contentType) {
    return contentType.match("turbo-stream.html") !== null
  }

  debug(message, data) {
    Log.debug("Turbo Button - " + message, data)
  }
}
